import { render, staticRenderFns } from "./DataImportView.vue?vue&type=template&id=23ea9896&scoped=true&"
import script from "./DataImportView.vue?vue&type=script&lang=js&"
export * from "./DataImportView.vue?vue&type=script&lang=js&"
import style0 from "./DataImportView.vue?vue&type=style&index=0&id=23ea9896&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23ea9896",
  null
  
)

export default component.exports